import React, { useRef, useState } from 'react';
import styled from 'styled-components';

import { Camera, CameraType } from "react-camera-pro";
import { IconButton } from '@mui/material';
import { CameraAlt, Cancel, Camera as CameraIcon,FlipCameraIos} from '@mui/icons-material';

const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 1;
`;

const Control = styled.div`
  position: fixed;
  display: flex;
  right: 0;
  width: 20%;
  min-width: 130px;
  min-height: 130px;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px;
  box-sizing: border-box;
  flex-direction: column-reverse;

  @media (max-aspect-ratio: 1/1) {
    flex-direction: row;
    bottom: 0;
    width: 100%;
    height: 20%;
  }

  @media (max-width: 400px) {
    padding: 10px;
  }
`;







interface ErrorMessagesCam {
    noCameraAccessible?: string;
    permissionDenied?: string;
    switchCamera?: string;
    canvas?: string;
};
interface Props{
    callback:(value:any)=>void
    cancel:()=>void
}
const CameraImage = ({callback,cancel}:Props) => {
  const [numberOfCameras, setNumberOfCameras] = useState(0);
  const [image, setImage] = useState<any | null>(null);
  const [errorMessagesCam, setErrorMessagesCam] = useState<ErrorMessagesCam>({})
  const camera = useRef<CameraType>(null);

  return (
    <Wrapper>
      <Camera errorMessages={errorMessagesCam} ref={camera} aspectRatio="cover" numberOfCamerasCallback={setNumberOfCameras} facingMode='environment'/>
      <Control>

        <IconButton
            size='large'
            title='Cancelar'
            onClick={cancel}

        >
            <Cancel sx={{fontSize:40}}/>
        </IconButton>  

        <IconButton
          onClick={() => {
            if (camera.current) {
              const photo = camera.current.takePhoto();
              callback(photo)              
              setImage(photo);
            }
          }}
        >
            <CameraIcon sx={{fontSize:60}} />
        </IconButton>      

        <IconButton
          disabled={numberOfCameras <= 1}
          onClick={() => {
            if (camera.current) {
              const result = camera.current.switchCamera();
              console.log(result);
            }
          }}        
        >
            <FlipCameraIos sx={{fontSize:40}} />
        </IconButton>

      </Control>
    </Wrapper>
  );
};

export default CameraImage;